<template>
    <jet-form-section @submitted="updateProfileBio">
        <template #title> Profile Bio </template>

        <template #description>Update your profile's bio.</template>

        <template #form>
            <div class="col-span-6">
                <jet-label for="bio" value="Bio" />
                <jet-textarea id="bio" v-model="form.bio" class="block mt-1 w-full h-32" autocomplete="off" data-lpignore="true" />
                <jet-input-error :message="form.errors.bio" class="mt-2" />
            </div>
        </template>

        <template #actions>
            <jet-action-message :show="form.recentlySuccessful" class="mr-3">
                <div class="flex items-center space-x-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Saved</span>
                </div>
            </jet-action-message>

            <jet-button :processing="form.processing"> Save </jet-button>
        </template>
    </jet-form-section>
</template>

<script>
import JetButton from "@/Jetstream/Button"
import JetFormSection from "@/Jetstream/FormSection"
import JetInputError from "@/Jetstream/InputError"
import JetLabel from "@/Jetstream/Label"
import JetActionMessage from "@/Jetstream/ActionMessage"
import JetSecondaryButton from "@/Jetstream/SecondaryButton"
import JetTextarea from "@/Jetstream/Textarea"

export default {
    components: {
        JetTextarea,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
    },

    data() {
        return {
            user: this.$page.props.user,
            form: this.$inertia.form({
                _method: "POST",
                bio: this.$page.props.user.bio,
            }),
        }
    },

    methods: {
        updateProfileBio() {
            this.form.clearErrors()
            this.form.processing = true
            this.form
                .transform((data) => ({
                    ...data,
                    bio: data.bio,
                }))
                .post(route("settings.bio.update"), {
                    errorBag: "updateProfileBio",
                    preserveScroll: true,
                    onFinish: () => (this.form.processing = false),
                })
        },
    },
}
</script>
